<div *ngIf="enableDiv">
  <label>{{ label }} <sup *ngIf="controls[1]?.invalid || controls[2]?.invalid || controls[3]?.invalid"
      class="red-text">*</sup>
    <span class="optional-t" [hidden]="!optionalSameLine">({{ optionalSameLine }})</span>
    <form-help [hidden]="!help">{{ help }}</form-help>
  </label>
  <div class="row" *ngIf="phoneInputForm"
    [class.has-error]="(showErrors || phoneInputForm.get('number').touched) && (controls[1]?.invalid || controls[2]?.invalid || controls[3]?.invalid)">
    <div class="col-4 pr-0">
      <div class="form-control disabled">{{ controls[0]?.value }}</div>

    </div>
    <div class="col">
      <input class="input-control one-input {{ faxExtension ? 'border-r' : '' }}"
        [formControl]="phoneInputForm.get('number')" type="text" [placeholder]="placeholder || 'Number'"
        [maxlength]="phoneInputForm.get('countryCode').value === '94' ? 10 : 15" />
      <i *ngIf="mobileVerifyTick" class="check fas fa-light fa-circle-check"></i>
    </div>
    <div class="col-3" [hidden]="!enableExtension">
      <input class="input-control  {{ faxExtension ? 'fax-i' : '' }}" [formControl]="phoneInputForm.get('extension')"
        type="text" placeholder="Ext" maxlength="5" />
    </div>
  </div>
</div>
<div *ngIf="!enableDiv">
  <label>{{ label }}
    <form-help [hidden]="!help">{{ help }}</form-help>
  </label>
  <div class="row" *ngIf="phoneInputForm"
    [class.has-error]="(showErrors || phoneInputForm.get('number').touched) && (controls[1]?.invalid || controls[2]?.invalid || controls[3]?.invalid)">
    <div class="col-4 pr-0">
      <div class="form-control disabled">{{ controls[0]?.value }}</div>
    </div>
    <div class="col ps-0">
      <input class="input-control" [formControl]="phoneInputForm.get('number')" type="text"
        [placeholder]="placeholder || 'Enter your mob number'"
        [maxlength]="phoneInputForm.get('countryCode').value === '94' ? 10 : 15" />
    </div>
    <div class="col-3" [hidden]="!enableExtension">
      <input class="input-control" [formControl]="phoneInputForm.get('extension')" type="text" placeholder="Ext"
        maxlength="5" />
    </div>
  </div>
</div>
<div class="error-message"
  *ngIf="(showErrors || phoneInputForm.get('number').touched) && (controls[1]?.invalid || controls[2]?.invalid || controls[3]?.invalid)">
  <ng-content></ng-content>
</div>